/**
 *@author: Sirisha.M
 *@Description : This component is mainly for creating failure Report Permissions 
 **/
/* eslint-disable no-unused-vars */

import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Form, Input, Button, message, Checkbox, Table } from 'antd';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import Highlighter from 'react-highlight-words';
import { SearchOutlined } from '@ant-design/icons';
import localStorage from '../../../utils/localStorage';
// import { constant } from '../Constants';
import { API_ROLE ,API_MASTERCONFIGURATION} from '../../../commons/api';
import StyledTable from '../../../commons/styles/table';
import '../style.css';
const FracasPermissions = (props) => {
  const [checkedValue, setCheckedValue] = useState([]);
  const [Roles, setRoles] = useState({});
  const [RolesList, setRolesList] = useState([]);
  const [datasource, setDatasource] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const [checkedPermissions, setCheckedPermissions] = useState({});
  const [PermissionsList, setPermissionsList] = useState([]);

  const hRef = useRef(null);
  const rRef = useRef(null);

  const searchInput = useRef(null);

  useEffect(() => {
    const fetchData = async () => {
      let RolesList = await getRolesList();
      setRolesList(RolesList);
      let datasource = await getList();
      setDatasource(datasource && datasource.RolesAndPermissions);
      let Permissions = await getPermissions();
      setPermissionsList(Permissions);
    };
    fetchData();
  }, []);

  const getRolesList = async () => {
    const accessToken = localStorage.get('accessToken');
    const siteId = localStorage.get('currentSite');
    const config = {
      method: 'GET',
      url: `${API_ROLE.GET}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    return axios(config)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        message.info(err && err.response && err.response.data && err.response.data.message);
      });
  };
  const getList = async () => {
    const accessToken = localStorage.get('accessToken');
    const siteId = localStorage.get('currentSite');
    const config = {
      method: 'GET',
      url: `/api/permission/get?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    return axios(config)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        message.info(err && err.response && err.response.data && err.response.data.message);
      });
  };
  const translation = (keyword) => {
    let { translationCache } = props;
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };

  const onFinish = async () => {
    try {
      const data = rRef.current.getFieldsValue();
      // Process form data to match the desired output
      const processedData = {
        Roles: data.Roles.map((role) => {
          return role;
        })
      };

      const response = await submitRoles(processedData.Roles);
      if (response && response.status && response.status === 200) {
        message.success(response && response.data && response.data.message);
        rRef.current &&
          rRef.current.setFieldsValue({
            Roles: []
          });
      } else {
        message.warning('Error while submitting');
      }
    } catch (error) {
      console.error('Error in onFinish:', error);
    }
  };
  const submitRoles = async (data) => {
    const siteId = localStorage.get('currentSite');
    const token = localStorage.get('accessToken');
    var Authorization = 'Bearer ' + token;
    const parameterGroup = {
      method: 'POST',
      url: `/api/permission/create?SiteId=${siteId}&ModuleCode=FRACAS`,
      headers: {
        Authorization: Authorization
      },
      data: data
    };

    return axios(parameterGroup)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        if (
          (err && err.response && err.response.status && err.response.status === 400) ||
          err.response.status === 500
        ) {
          message.info(err.response.data.message);
        }
      });
  };
  const updateRoles = async (data) => {
    const siteId = localStorage.get('currentSite');
    const token = localStorage.get('accessToken');
    var Authorization = 'Bearer ' + token;
    const parameterGroup = {
      method: 'PATCH',
      url: `/api/permission/patch?SiteId=${siteId}`,
      headers: {
        Authorization: Authorization
      },
      data: data
    };

    return axios(parameterGroup)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        if (
          (err && err.response && err.response.status && err.response.status === 400) ||
          err.response.status === 500
        ) {
          message.info(err.response.data.message);
        }
      });
  };
  // const TabsList=['Reporting','Assign User','Assign Department']
  const onCheckScreen = (e, name, key) => {
    const itemExists = checkedValue.some((e) => e === key);
    let updatedArray;
    if (itemExists) {
      updatedArray = checkedValue.filter((val) => val !== key);
    } else {
      updatedArray = [...checkedValue, key];
    }
    setCheckedValue(updatedArray);
  };
  const onCancel = () => {
    rRef.current &&
      rRef.current.setFieldsValue({
        Roles: []
      });
  };
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={translation(`Search ${dataIndex}`)}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}
          
          style={{ width: 90, marginRight: 8 }}
        >
          {translation('Search')}
        </Button>
        <Button
          onClick={() => handleReset(clearFilters, confirm)}
          
          style={{ width: 90 }}
        >
          {translation('Reset')}
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),

    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  });

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    handleSearch([], confirm);
  };
  const handleCheck = async (record, permissionId, checked) => {
    setCheckedPermissions((prev) => {
      const newChecked = { ...prev };
      if (!newChecked[record.Role]) newChecked[record.Role] = {};
      newChecked[record.Role][permissionId] = checked;
      return newChecked;
    });
    let payload = {
      RolesAndPermissions: [
        {
          Role: record.Role,
          permissions: [permissionId]
        }
      ]
    };
    if (checked === true) {
      const response = await submitRoles(payload);
      if (response && response.status && response.status === 200) {
        message.success(response && response.data && response.data.message);
        let datasource = await getList();
        setDatasource(datasource && datasource.RolesAndPermissions);
      } else {
        message.warning('Error while submitting');
      }
    } else {
      const response = await updateRoles(payload);
      if (response && response.status && response.status === 200) {
        message.success(response && response.data && response.data.message);
        let datasource = await getList();
        setDatasource(datasource && datasource.RolesAndPermissions);
      } else {
        message.warning('Error while Updating');
      }
    }
  };

  const getPermissions = () => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    try {
      const uomObject = {
        method: 'POST',
        url: `${API_MASTERCONFIGURATION.Master}?SiteId=${siteId}`,
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        data: {
          MasterCode: 'Master_Screen',
          ActionType: 'read',
          Type: 'WithSiteId'
        }
      };
      return axios(uomObject)
        .then((response) => {
          return response.data;
        })
        .catch(() => {
          return [];
        });
    } catch (err) {
      return err;
    }
  };
  const TabsList = ['Reporting', 'Assign User', 'Assign Department'];

  const columns = [
    {
      title: translation('Roles'),
      dataIndex: 'RoleName',
      ...getColumnSearchProps('RoleName')
    },
    {
      title: translation('Permissions'),
      dataIndex: 'permissions',
      render: (permissions, record) => (
        <div style={{ display: 'flex', gap: '10px' }} className="label-color">
          {PermissionsList &&
            Array.isArray(PermissionsList) &&
            PermissionsList.map((permission) => (
              <div key={permission.Id}>
                <Checkbox
                  value={permission.Id}
                  checked={
                    permissions.includes(permission.ScreenName) ||
                    checkedPermissions[record.Role]?.[permission.ScreenName] ||
                    false
                  }
                  onChange={(e) => handleCheck(record, permission.ScreenName, e.target.checked)}
                >
                  {permission.ScreenName}
                </Checkbox>
              </div>
            ))}
        </div>
      )
    }
  ];

  return (
      <StyledTable size="small"
          columns={columns}
          dataSource={datasource}
         
        />
    
  );
};

const mapStateToProps = (state) => ({
  translationCache: state.TranslationReducer.translationCache,
});

export default connect(mapStateToProps)(FracasPermissions);